import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-section">
                    <h3>Services</h3>
                    <ul>
                        <li>Web Development</li>
                        <li>AI Development</li>
                        <li>Custom Development</li>
                    </ul>
                </div>
                <div className="footer-section">
                    <h3>Company</h3>
                    <ul>
                        <li>About Us</li>
                        <li>Careers</li>
                        <li>Contact Us</li>
                    </ul>
                </div>
                <div className="footer-section">
                    <h3>Connect Us</h3>
                    <ul className="contact-info">
                        <li>
                            <span className="label">Email</span>
                            <span className="separator">:</span>
                            <span className="value">admin@blusuite.in</span>
                        </li>
                    </ul>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
